<div class="loader-wrapper" [style.min-height.px]="minHeight">
  <mat-spinner [diameter]="diameter"></mat-spinner>
</div>
